<template>
  <div>
    <el-form label-width="120px">
      <el-form-item label="用户手机号">
        <el-input v-model="obj.phone_number"></el-input>
      </el-form-item>
      <el-form-item label="确认手机号">
        <el-input v-model="obj.phone_number_makesure"></el-input>
      </el-form-item>
      <!-- <el-form-item label="用户密码">
        <el-input value="12345678" disabled></el-input>
      </el-form-item> -->
      <el-form-item label="开通时间">
        <el-select v-model="obj.year" placeholder="请选择">
          <el-option v-for="(item,i) in yearList" :key="i" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="功能">
        <el-checkbox-group v-model="obj.model" style="display: inline-block;margin-right: 10px;">
          <el-checkbox :label="item.id" name="type" v-for="(item,index) in moduleList" :key="index">{{item.name}}</el-checkbox>
          <!-- <el-checkbox label="9" name="type">算料</el-checkbox>
		  <el-checkbox label="14" name="type">型材优化</el-checkbox>
		  <el-checkbox label="15" name="type">客户管理</el-checkbox>
		  <el-checkbox label="16" name="type">异形算料</el-checkbox>
		  <el-checkbox label="19" name="type">玻璃算料</el-checkbox>
		  <el-checkbox label="18" name="type">实景渲染</el-checkbox>
		  <el-checkbox label="17" name="type">财务管理</el-checkbox>
		  <el-checkbox label="999" name="type">型材商</el-checkbox> -->
		  <!-- <el-checkbox label="99" name="type">体验版</el-checkbox> -->
        </el-checkbox-group>
		<el-checkbox v-model="annual" name="type">年费</el-checkbox>
		<div v-if="annual">
			<label for="" class="input-label">年费:</label>
			<el-input v-model="obj.annual_fee" type="number" class="input-line"></el-input>
		</div>
		<div v-if="obj.model.indexOf('999') > 0">
			<label for="" class="input-label">客户数量:</label>
			<el-input v-model="obj.customer_number" type="number" class="input-line"></el-input>
		</div>
      </el-form-item>
	  <el-form-item label="炫图版本" v-if="obj.model.indexOf(28) > -1">
	    <el-select v-model="obj.module_28_status" placeholder="请选择">
	      <el-option label="年费" :value="1"></el-option>
	      <el-option label="永久" :value="2"></el-option>
	      <el-option label="次数" :value="3"></el-option>
	    </el-select>
	  </el-form-item>
	  <el-form-item label="渲图次数" v-if="obj.model.indexOf(28) > -1 && obj.module_28_status == 3">
	    <el-input type="number" v-model.number="obj.module_28_times" min="0"></el-input>
	  </el-form-item>
	  <el-form-item label="子账号数量">
	    <el-input type="number" v-model.number="obj.user_count" min="0"></el-input>
	  </el-form-item>
	  <el-form-item label="车间员工数量">
	    <el-input type="number" v-model.number="obj.workshop_users" min="1"></el-input>
	  </el-form-item>
	  <el-form-item label="语言">
	    <el-checkbox-group v-model="langList" style="display: inline-block;margin-right: 10px;">
	      <el-checkbox :label="item.value" name="type" v-for="(item,index) in langAvailableList" :key="index">{{item.name}}</el-checkbox>
	    </el-checkbox-group>
	  </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="obj.note"></el-input>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="submit">确定创建</el-button>
    <el-button type="primary" @click="forgetPassword">重置密码</el-button>
	<el-button type="primary" @click="changeLang">修改语言</el-button>
	
	<el-form label-width="120px" style="margin-top: 20px;">
		
	</el-form>
  </div>
</template>

<script>
export default {
  data:()=>({
    obj:{
      phone_number:'',
      phone_number_makesure:'',
      year:1000,
      model:['3'],
      note: "",
	  user_count: 0,
	  annual_fee: '',
	  customer_number: '',
	  module_28_times: 30
    },
    yearList:[
	  {label:'半年',value:0.5},
      {label:'1年',value:1},
      {label:'2年',value:2},
      {label:'3年',value:3},
      {label:'永久',value:1000},
    ],
	annual: false,
	moduleList: [],
	langList: ['zh-CN','en-US'],
	langAvailableList: [
		{ name: '中文',value: 'zh-CN' },
		{ name: '英文',value: 'en-US' },
		{ name: '越南',value: 'vi-VN' }
	]
  }),
  methods:{
    submit(){
      if(this.obj.phone_number!=this.obj.phone_number_makesure){
        this.$message.error("两次手机号不匹配！");
        return
      }
      if(!this.obj.year){
        this.$message.error("请选择账号开通时间！");
        return
      }
      var param = JSON.parse(JSON.stringify(this.obj))
      if(param.model.length==0){
        delete param.model
      }
	  if(param.model.indexOf('999') < 0) {
		  delete param.customer_number
	  }
      delete param.phone_number_makesure
	  if(!this.annual) delete param.annual_fee
	  param.model.sort((a,b) =>{return a-b})
	  param.language = this.langList.toString()
      this.$axios.post('admin-add-user',param).then(res=>{
        if(res.code==1){
          this.$message({
            message:"创建成功",
            type:"success"
          })
        }else{
          this.$message.error(res.message)
        }
      })
    },
	getModuleList() {
		this.$axios.post('model_list').then(res=>{
		  if(res.code==1){
		    this.moduleList = res.data
		  }else{
		    this.$message.error(res.message)
		  }
		})
	},
	forgetPassword() {
		let params = {
			phone_number: this.obj.phone_number
		}
		this.$axios.post('admin-up-pwd',params).then(res=>{
		  if(res.code==1){
			  this.$message.success(res.message)
		  }else{
		    this.$message.error(res.message)
		  }
		})
	},
	changeLang() {
		let params = {
			phone_number: this.obj.phone_number,
			language: this.langList.toString()
		}
		this.$axios.post('admin-up-language',params).then(res=>{
		  if(res.code==1){
		    this.$message({
		      message:"修改成功",
		      type:"success"
		    })
		  }else{
		    this.$message.error(res.message)
		  }
		})
	}
  },
  mounted() {
	  this.getModuleList()
  }
}
</script>

<style scoped lang="scss">
	.input-label{
		display: inline-block;
		width: 70px;
	}
	.input-line{
		width: 300px;
		display: inline-block;
		margin-top: 10px;
	}
</style>